<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import MsoAddEditForm from "@/components/models/practice/forms/MsoAddEditForm.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useMso } from "@/composables/models/practice/useMsos";
import { useCanEditMso } from "@/composables/shared/useSectionPermissions";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.mso" },
    checkPrivileges: () => useCanEditMso().value,
  },
});

const route = useRoute();
const msoId = computed(() => (route.params as { id: string }).id);
const { data: defaultValues, isLoading } = useMso({ id: msoId.value });
</script>

<template>
  <loading v-if="isLoading" />
  <mso-add-edit-form
    v-else
    :defaultValues
  />
</template>
